import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffPeikOrdersNewWithShift(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formShopCode, setFormShopCode] = useState(null);
    const [formPayablePrice, setFormPayablePrice] = useState(null);
    const [formTotalListPrice, setFormTotalListPrice] = useState(null);
    const [formBoxVolume, setFormBoxVolume] = useState(null);
    const [formTotalWeight, setFormTotalWeight] = useState(null);
    const [formAddress, setFormAddress] = useState(null);
    const [formCustomerName, setFormCustomerName] = useState(null);
    const [formCustomerMobile, setFormCustomerMobile] = useState(null);
    const [formCustomerPhone, setFormCustomerPhone] = useState(null);
    const [formShiftId, setFormShiftId] = useState(null);
    const [formShiftIdOptions, setFormShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-peik-orders-new-with-shift/select-data/shift-id').then(
            (response) => {
                setFormShiftIdOptions(response.data);
            }
        );
    }, []);
    const [formNote, setFormNote] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-peik-orders-new-with-shift/save-data', {
            title: formTitle,
            shop_code: formShopCode,
            payable_price: formPayablePrice,
            total_list_price: formTotalListPrice,
            box_volume: formBoxVolume,
            total_weight: formTotalWeight,
            address: formAddress,
            customer_name: formCustomerName,
            customer_mobile: formCustomerMobile,
            customer_phone: formCustomerPhone,
            shift_id: formShiftId,
            note: formNote,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد سفارش</Title>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox label={'عنوان *'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'کد رهگیری در فروشگاه'}
                            value={formShopCode}
                            onChange={setFormShopCode}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'مبلغ قابل پرداخت *'}
                            value={formPayablePrice}
                            onChange={setFormPayablePrice}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'ارزش کالا *'}
                            value={formTotalListPrice}
                            onChange={setFormTotalListPrice}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'حجم بسته'}
                            value={formBoxVolume}
                            onChange={setFormBoxVolume}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'وزن کل'}
                            value={formTotalWeight}
                            onChange={setFormTotalWeight}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'آدرس *'} value={formAddress} onChange={setFormAddress} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'نام خریدار *'}
                            value={formCustomerName}
                            onChange={setFormCustomerName}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'همراه خریدار *'}
                            value={formCustomerMobile}
                            onChange={setFormCustomerMobile}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'شماره ثابت'}
                            value={formCustomerPhone}
                            onChange={setFormCustomerPhone}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <DataSelect
                            label={'شیفت ارسال *'}
                            options={formShiftIdOptions}
                            value={formShiftId}
                            onChange={setFormShiftId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'یادداشت'} value={formNote} onChange={setFormNote} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
